import { ConfigurationCriteriaEnum } from 'src/features/configuration/configurationCriteria/enums/ConfigurationCriteriaEnum';
import {
  OpenSessionCriteria,
  OpenSessionCriterion,
} from 'src/services/api/getOpenSessionCriteria';

const DEFAULT_CRITERION_VALUES: Partial<
  Record<ConfigurationCriteriaEnum, Record<string, string | number>>
> = {
  [ConfigurationCriteriaEnum.DestockingLastDays]: { value1: 60 },
};

export function useConfigurationCriteria(data: OpenSessionCriteria) {
  const getCriterion = (
    key: ConfigurationCriteriaEnum,
  ): OpenSessionCriterion => {
    const found = data.find((criterion) => criterion.name === key);
    if (found) {
      return found;
    }
    // Return a default criterion if not found in API response
    return {
      name: key,
      values: DEFAULT_CRITERION_VALUES[key] ?? {},
      products: [],
      apply: false,
    };
  };

  return {
    getCriterion,
  };
}
